import { LOCALE } from "./constants";

export const calendarDayNames = () => {
    const names = {
        "en-US" : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        "en-CA" : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        "pt-BR" : ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
        //"zh-CN" : ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    };

    return names[LOCALE] || names["en-US"];
}

export const dayNamesShort = () => {
    const names = {
        "en-US" : ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'],
        "en-CA" : ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat']
    };

    return names[LOCALE] || names["en-US"];
}

export const dayNamesFull = () => {
    const names = {
        "en-US" : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        "en-CA" : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    };

    return names[LOCALE] || names["en-US"];
}

export const monthNamesFull = () => {
    const names = {
        "en-US" : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        "en-CA" : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        "pt-BR" : ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
    };

    return names[LOCALE] || names["en-US"];
}

export const monthNamesShort = () => {
    const names = {
        "en-US" : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        "en-CA" : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    };

    return names[LOCALE] || names["en-US"];
}